// extracted by mini-css-extract-plugin
export default {"title":"Home_title__Jvuqu","anchor":"Home_anchor__tHQdq","item":"Home_item__nI5la"};